import { Icon } from '@chakra-ui/react';

export const CheckCircle = (props) => (
  <Icon viewBox="0 0 16 16" fill="none" {...props}>
    <path
      opacity="0.4"
      d="M14.3763 9.26855C14.2927 9.69123 14.1681 10.0992 14.0068 10.4881C13.6774 11.2826 13.195 11.9975 12.5962 12.5962C11.42 13.7725 9.795 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 6.205 2.2275 4.58 3.40375 3.40375C4.00246 2.80504 4.71744 2.32259 5.51192 1.99316C6.2783 1.67538 7.11866 1.5 8 1.5C8.53215 1.5 9.0493 1.56386 9.54432 1.68444"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.5L8 9.5L15 2.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
